import { useState, useEffect } from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import styles from "./App.module.scss";
import Header from "./components/Header/Header";
import Admin from "./page/Admin/Admin";
import Culture from "./page/Culture/Culture";
import FAQ from "./page/FAQ/FAQ";
import Footer from "./page/Footer/Footer";
import InputApply from "./page/InputApply/InputApply";
import Job from "./page/Job/Job";
import JobDetail from "./page/JobDetail/JobDetail";
import Main from "./page/Main/Main";
import Submission from "./page/Submission/Submission";
import { AuthProvider } from "./Context/AuthContext";
import AuthService from "./service/auth";
import "monoff-web-design-system/src/components/input.css";
import "monoff-web-design-system/src/components/button.css";
import "monoff-web-design-system/src/fonts.css";
import "monoff-web-design-system/src/variable.css";

const authService = new AuthService("https://server.mondayoff.me");
export default function App() {
  const [isSidebar, setIsSidebar] = useState<boolean>(false);
  const [isDarkMode, setIsDarkMode] = useState<boolean>(false);
  const [isSelect, setIsSelect] = useState<string>("");
  const [width, setWidth] = useState(window.innerWidth);
  const { pathname } = useLocation();
  const select = (menu: string): boolean => {
    return isSelect === menu;
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  // useEffect(() => {

  //   const bgMode = window.localStorage.getItem("bgMode");
  //   if (bgMode === "dark") {
  //     document.getElementsByTagName("html")[0].classList.add("ui-dark");
  //     setIsDarkMode(true);
  //   } else {
  //     setIsDarkMode(false);
  //   }
  // }, []);
  useEffect(() => {
    if (window.localStorage.getItem("bgMode")) {
      window.localStorage.removeItem("bgMode");
    }
  }, []);
  const darkOnOff = (): void => {
    if (
      document.getElementsByTagName("html")[0].classList.contains("ui-dark")
    ) {
      document.getElementsByTagName("html")[0].classList.remove("ui-dark");
      localStorage.setItem("bgMode", "light");
      setIsDarkMode(false);
    } else {
      document.getElementsByTagName("html")[0].classList.add("ui-dark");
      localStorage.setItem("bgMode", "dark");
      setIsDarkMode(true);
    }
  };

  const handleResize = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      // cleanup
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      <Header
        isDarkMode={isDarkMode}
        darkOnOff={darkOnOff}
        isSidebar={isSidebar}
        setIsSidebar={setIsSidebar}
        select={select}
        setIsSelect={setIsSelect}
        width={width}
      />
      <div className={styles.App}>
        <Routes>
          {/* <Route
            path="/"
            element={<Main isDarkMode={isDarkMode} width={width} />}
          /> */}
          <Route path="/" element={<Navigate replace to="/position" />} />
          <Route
            path="/culture"
            element={<Culture isDarkMode={isDarkMode} width={width} />}
          />
          <Route
            path="/position"
            element={
              <Job
                isDarkMode={isDarkMode}
                isSidebar={isSidebar}
                width={width}
              />
            }
          />
          <Route path="/faq" element={<FAQ />} />
          <Route
            path="/position/:id"
            element={<JobDetail isDarkMode={isDarkMode} width={width} />}
          />
          <Route
            path="/position/apply"
            element={<InputApply isDarkMode={isDarkMode} width={width} />}
          />
          <Route
            path="/position/submission"
            element={<Submission isDarkMode={isDarkMode} />}
          />
          <Route
            path="/admin"
            element={
              <AuthProvider authService={authService}>
                <Admin />
              </AuthProvider>
            }
          />
        </Routes>
      </div>

      <Footer isSidebar={isSidebar} setIsSelect={setIsSelect} />
    </>
  );
}
